import { render, staticRenderFns } from "./selectPerson_v.vue?vue&type=template&id=aba69622&scoped=true"
import script from "./selectPerson_v.vue?vue&type=script&lang=js"
export * from "./selectPerson_v.vue?vue&type=script&lang=js"
import style0 from "./selectPerson_v.vue?vue&type=style&index=0&id=aba69622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba69622",
  null
  
)

export default component.exports